import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';

import sliderImg1 from '../../assets/img/slider/gemasan-4.svg';
import promoVideo from '../../assets/video/Gemasan.mp4';

const Banner = () => {
  const [isOpen, setIsOpen] = useState(false);
  const openModal = () => {
    setIsOpen(true);
    setTimeout(() => {
      if (videoRef.current) {
        const v = videoRef.current;
        try {
          v.muted = false;
          v.currentTime = 0;
          const p = v.play();
          if (p && p.catch) p.catch(() => { }); // play() kesilse de konsola hata düşmesin
        } catch (e) { }
      }
    }, 0);
  };

  const closeModal = () => {
    if (videoRef.current) {
      const v = videoRef.current;
      v.pause();
      v.currentTime = 0;
    }
    setIsOpen(false);
  };

  const videoRef = useRef(null);

  return (
    <div className="slider__area grey-bg slider__space slider__plr p-relative z-index fix">
      <div
        onClick={closeModal}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.7)',
          zIndex: 10000,
          display: isOpen ? 'flex' : 'none',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{ position: 'relative', width: '90%', maxWidth: '960px' }}
        >
          <button onClick={closeModal} aria-label="Kapat" style={{ /* ... */ }}>×</button>
          <video
            ref={videoRef}
            src={promoVideo}
            controls
            playsInline
            style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
          />
        </div>
      </div>

      <div className="container-fluid" style={{ paddingLeft: '15px', paddingRight: '15px' }}>
        <div className="row align-items-center">
          <div className="col-xl-6 col-lg-6 col-md-12 col-12 order-2 order-md-1">
            <div
              className="slider__section-box"
              style={{
                paddingBottom: '20px',
                paddingLeft: '0',
                paddingRight: '0'
              }}
            >
              <h4
                className="section-subtitle char-anim wow animate__fadeInUp"
                data-wow-duration="1.1s"
                data-wow-delay=".3s"
                style={{
                  fontSize: 'clamp(11px, 2vw, 14px)',
                  padding: 'clamp(5px, 1.2vw, 8px) clamp(12px, 2.5vw, 25px)',
                  marginBottom: 'clamp(8px, 1.5vw, 12px)',
                  display: 'inline-block',
                  backgroundColor: '#2a3658',
                  color: '#ffffff',
                  borderRadius: '30px'
                }}
              >
                Denizleri Keşfetmeye Hazır Ol!
              </h4>
              <h3
                className="hero-title char-anim wow animate__fadeInUp"
                data-wow-duration="1.1s"
                data-wow-delay=".3s"
                style={{
                  fontSize: 'clamp(18px, 4vw, 32px)',
                  lineHeight: '1.35',
                  marginBottom: 'clamp(12px, 2.5vw, 18px)',
                  fontWeight: '700',
                  paddingRight: '0',
                  color: '#2a3658'
                }}
              >
                Denizcilik sektöründe ileri teknolojik sistemler tasarlıyor ve geliştiriyoruz.
              </h3>
            </div>
            <div
              className="slider__content wow animate__fadeInUp"
              data-wow-duration="1.1s"
              data-wow-delay=".3s"
              style={{
                paddingBottom: 'clamp(12px, 2.5vw, 20px)',
                paddingLeft: '0',
                paddingRight: '0'
              }}
            >
              <p
                className="char-anim-2"
                style={{
                  fontSize: 'clamp(12px, 2.3vw, 14px)',
                  lineHeight: '1.7',
                  paddingRight: '0',
                  marginBottom: '0',
                  color: '#2a3658',
                  fontWeight: '400'
                }}
              >
                Gemi altı temizliği ve gemi altı görüntüleme hizmetleri sunuyoruz. Su altı operasyonlarında robotik platformlar geliştiriyor, karmaşık görevleri gerçekleştirebilen çok fonksiyonlu manipülatör sistemleri üretiyoruz. Deniz araçlarına gerçek zamanlı çevresel farkındalık kazandıran yapay zekâ tabanlı seyir destek çözümleri tasarlıyoruz.
              </p>
            </div>
            <div
              className="slider__btn wow animate__fadeInUp"
              data-wow-duration="1.1s"
              data-wow-delay=".5s"
              style={{
                paddingTop: 'clamp(8px, 1.5vw, 12px)',
                paddingBottom: '0'
              }}
            >
              <div
                className="about__video d-flex justify-content-start align-items-center"
                style={{
                  border: '1.5px solid #2a3658',
                  borderRadius: '30px',
                  padding: 'clamp(4px, 0.8vw, 6px) clamp(10px, 1.5vw, 14px)',
                  display: 'inline-flex',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  width: 'fit-content'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#2a3658';
                  e.currentTarget.style.borderColor = '#1a2540';
                  e.currentTarget.querySelector('.about__video-text a').style.color = '#ffffff';
                  e.currentTarget.querySelector('.about__video-icon a').style.backgroundColor = '#ffffff';
                  e.currentTarget.querySelector('.about__video-icon a i').style.color = '#2a3658';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.borderColor = '#2a3658';
                  e.currentTarget.querySelector('.about__video-text a').style.color = '#2a3658';
                  e.currentTarget.querySelector('.about__video-icon a').style.backgroundColor = '#2a3658';
                  e.currentTarget.querySelector('.about__video-icon a i').style.color = '#ffffff';
                }}
                onClick={() => {
                  if (!isOpen) openModal();
                  if (videoRef.current) {
                    try {
                      videoRef.current.muted = false;
                      videoRef.current.currentTime = 0;
                      videoRef.current.play();  // kullanıcı tıklaması içinde sesli başlat
                    } catch (_) { }
                  }
                }}
              >
                <div className="about__video-icon">
                  <Link
                    to="#"
                    className="popup-video"
                    onClick={(e) => { e.preventDefault(); }}
                    style={{
                      backgroundColor: '#2a3658',
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      lineHeight: '32px',
                      textAlign: 'center',
                      display: 'inline-block',
                      position: 'relative',
                      zIndex: 1,
                      marginRight: '0'
                    }}
                  >
                    <i
                      className="fas fa-play"
                      style={{
                        fontSize: '11px',
                        color: '#ffffff',
                        marginLeft: '2px'
                      }}
                    ></i>
                  </Link>
                </div>
                <div className="about__video-text">
                  <Link
                    to="#"
                    onClick={(e) => { e.preventDefault(); }}
                    style={{
                      color: '#2a3658',
                      fontWeight: '500',
                      fontSize: 'clamp(12px, 1.5vw, 14px)',
                      marginLeft: 'clamp(6px, 1vw, 8px)',
                      textDecoration: 'none',
                      transition: 'color 0.3s ease'
                    }}
                  >
                    Video İzle
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 col-md-12 col-12 order-1 order-md-2 wow animate__fadeInRight"
            data-wow-duration="1.1s"
            data-wow-delay=".5s"
            style={{
              marginBottom: 'clamp(20px, 4vw, 30px)',
              paddingTop: 'clamp(10px, 2vw, 20px)',
              paddingLeft: '0',
              paddingRight: '0'
            }}
          >
            <div
              className="slider__thumb"
              style={{
                maxWidth: 'clamp(85%, 95%, 100%)',
                margin: '0 auto',
                textAlign: 'center',
                padding: '0 10px'
              }}
            >
              <img
                src={sliderImg1}
                alt="Gemasan Denizcilik Teknolojileri"
                style={{
                  width: '100%',
                  height: 'auto',
                  maxWidth: '100%',
                  objectFit: 'contain',
                  display: 'block'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;